import {makeStyles} from '@logistics-frontend/blocks'

import cargoIcon from './images/cargo.png'
import courierIcon from './images/courier.png'
import expressIcon from './images/express.png'

export const useClasses = makeStyles(
  theme => ({
    boldTitle: {
      // проблема старой темы
      // eslint-disable-next-line
      fontWeight: theme.typography.fontWeightMedium as any,
      fontSize: 18,
      padding: theme.spacing(0.5),
      lineHeight: '26px',
      [theme.breakpoints.down('sm')]: {
        paddingBottom: 0,
      },
    },
    title: {
      lineHeight: '16px',
    },
    subtitle: {
      fontSize: 12,
      lineHeight: '17px',
      fontWeight: 400,
    },
    icon: {
      height: 20,
      background: 'top left no-repeat',
      backgroundSize: 'auto 20px',
    },
    iconCourier: {
      backgroundImage: `url(${courierIcon})`,
    },
    iconExpress: {
      backgroundImage: `url(${expressIcon})`,
    },
    iconCargo: {
      backgroundImage: `url(${cargoIcon})`,
    },
    divider: {
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      },
    },
    svgIcon: {
      alignSelf: 'flex-end',
    },
    price: {
      marginTop: 'auto',
    },
  }),
  {name: 'Tariffs'},
)

export const useTogglePlateGroupClasses = makeStyles(theme => ({
  root: {
    borderRadius: 0,
    padding: theme.spacing(0.5, 0),
    [theme.breakpoints.down('sm')]: {
      overflowX: 'scroll',
      width: `calc(100% + ${theme.spacing(3)}px)`,
      margin: theme.spacing(0, -1.5),
      padding: theme.spacing(0.5, 0, 2, 0),
      '&:last-child:after': {
        content: '""',
        flex: `0 0 ${theme.spacing(1.5)}px`,
      },
    },
  },
  groupedHorizontal: {
    margin: theme.spacing(0, 1.5),
    '&:first-child': {
      margin: theme.spacing(0, 1.5, 0, 0),
    },
    '&:last-child': {
      margin: theme.spacing(0),
    },
    '&:not(:first-child)': {
      borderRadius: 16,
    },
    '&:not(:last-child)': {
      borderRadius: 16,
    },
    [theme.breakpoints.down('sm')]: {
      '&:first-child': {
        margin: theme.spacing(0, 1.5),
      },
    },
  },
}))

export const useTogglePlateClasses = makeStyles(theme => ({
  root: {
    minWidth: 130,
    flexDirection: 'row',
    alignItems: 'stretch',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.palette.grey[300],
      padding: theme.spacing(1),
      '&$selected': {
        '&:hover': {
          backgroundColor: 'inherit',
        },
      },
      '&:last-child': {
        margin: 0,
      },
    },
  },
  selected: {},
}))
